import React from 'react';

import {InlineSvg, styles} from '@raison/ui-kit';

import apps2LineIcon from '@raison/static/icons/apps-2-line.svg';
import bitCoinLineIcon from '@raison/static/icons/bit-coin-line.svg';
import fileChartLineIcon from '@raison/static/icons/file-chart-line.svg';
import fileCopy2LineIcon from '@raison/static/icons/file-copy-2-line.svg';
import fileShield2LineIcon from '@raison/static/icons/file-shield-2-line.svg';
import transferFileLineIcon from '@raison/static/icons/transfer-file-line.svg';

const iconCls = styles({
    iconWrapper: 'flex size-9 items-center justify-center rounded-full bg-neutral-20',
    icon: 'size-4 text-neutral-90',
});

export const icons: Record<string, string> = {
    'apps-2-line': apps2LineIcon,
    'bit-coin-line': bitCoinLineIcon,
    'file-copy-2-line': fileCopy2LineIcon,
    'file-chart-line': fileChartLineIcon,
    'transfer-file-line': transferFileLineIcon,
    'file-shield-2-line': fileShield2LineIcon,
};

export const getIcon = (url: string) => {
    if (url.startsWith('local://')) {
        const [_, iconName] = url.split('://');
        const icon = icons[iconName] || apps2LineIcon;
        return {
            element: (
                <div className={iconCls.iconWrapper}>
                    <InlineSvg src={icon} className={iconCls.icon} />
                </div>
            ),
        };
    } else {
        return {
            src: url,
        };
    }
};
